import GraphQL from '@app/model/_common/service/GraphQL';
import { gql } from 'graphql-request';
import { SITE_NOTIFICATION_FRAGMENT } from '@app/model/site_notification/service/SiteNotificationGraphQLFragments';


export const FIND_UNACKNOWLEDGED_NOTIFICATIONS_QUERY: GraphQL = {
	name: "findUnacknowledgedNotifications",
	gql: gql`
      ${SITE_NOTIFICATION_FRAGMENT}
      query findUnacknowledgedNotifications($companyHotelId: Long!) {
          findUnacknowledgedNotifications(companyHotelId: $companyHotelId) {
              ...SiteNotificationFields
          }
      }
	`
}

export const ACKNOWLEDGE_NOTIFICATION_MUTATION: GraphQL = {
	name: "acknowledge",
	gql: gql`
      mutation acknowledge($notificationId: Long!) {
          acknowledge(notificationId: $notificationId) {
              exception
              success
          }
      }
	`
}